import React from "react";
import styles from "../help.scss";
import { StaticHTML } from "../../StaticHTML";
import HelmetComponent from "../../../utils/HelmetHelper";
const advertising = `<div>
    E-mail: <a href="mailto:prodaja@index.hr" style="color: #f94144">prodaja@index.hr</a><br>
    Mob: <a href="tel:+385989078504" style="color: #f94144">+385 98 907 8504</a><br>
  <br>
  Index promocija d.o.o.<br>
  <br>
  Radnička cesta 41<br>
  10 000 Zagreb<br>
  Hrvatska<br>
</div>`;

const Advertising = () => (
  <div className={styles.container}>
    <HelmetComponent
      title={`${"Banner oglašavanje"} | ${"INDEX OGLASI"}`}
    />
    <div className={styles.title}>{"Banner oglašavanje"}</div>
    <StaticHTML content={advertising} />
  </div>
);

export default Advertising;



// WEBPACK FOOTER //
// ./src/components/Help/Advertising/Advertising.tsx